import { useState, useRef, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

// Lightweight autocomplete: type to filter `items` by name; pick one or use free text.
export function SearchPicker({ items = [], value, onPick, placeholder = 'Search…', allowFreeText = true, clearOnPick = false, testid }) {
  const [q, setQ] = useState(value || '');
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => { setQ(value || ''); }, [value]);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const filtered = q.trim()
    ? items.filter(i => i.name.toLowerCase().includes(q.toLowerCase())).slice(0, 8)
    : items.slice(0, 8);

  return (
    <div className="relative" ref={ref}>
      <div className="relative">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input
          value={q}
          onChange={e => { setQ(e.target.value); setOpen(true); if (allowFreeText) onPick({ name: e.target.value }); }}
          onFocus={() => setOpen(true)}
          placeholder={placeholder}
          data-testid={testid}
          className="bg-[var(--c-film)] border-[var(--c-hair)] h-12 rounded-xl pl-9"
        />
      </div>
      {open && filtered.length > 0 && (
        <div className="absolute z-30 mt-1 w-full rounded-xl bg-[var(--c-elev)] border border-[var(--c-hair)] shadow-xl max-h-56 overflow-y-auto">
          {filtered.map(i => (
            <button
              key={i.id || i.name}
              type="button"
              onClick={() => { onPick(i); setQ(clearOnPick ? '' : i.name); setOpen(false); }}
              data-testid={`${testid}-opt-${(i.name || '').replace(/\s+/g, '-').toLowerCase()}`}
              className="w-full text-left px-4 py-2.5 hover:bg-[var(--c-film)] flex items-center justify-between"
            >
              <span className="text-sm">{i.name}</span>
              {i.category && <span className="text-[10px] text-muted-foreground">{i.category}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
